import React from 'react';

// Simplified label translation function
const getLable = (label, t) => {
  const labels = {
    lyingOnRight: t('on_right'),
    lyingOnLeft: t('on_left'),
    lyingOnBack: t('on_back'),
    lyingOnStomach: t('on_stomach'),
  };
  return labels[label] || '';
};

// LegendItem component for individual legend items
const LegendItem = ({ color, label, text, t }) => (
  <div className='flex flex-row my-auto'>
    <svg width={30} height={30}>
      <circle cx='50%' cy='50%' r='10' fill={color} />
    </svg>
    <div className='block w-32 my-auto'>
      <span className='text-lg text-summary-header'>{getLable(label, t)}</span>
    </div>
    <div className='w-16 my-auto ml-2'>
      <span className='text-lg font-semibold text-right text-summary-header'>
        {text}
      </span>
    </div>
  </div>
);

const SleepLegend = (props) => {
  const { data, colorset, t } = props;

  return (
    <div className='flex flex-col max-w-xs space-y-3'>
      {data
        .filter(({ label }) => 
          colorset.hasOwnProperty(label) &&
          !['total', 'mock', 'target'].includes(label)
        )
        .map((element, i) => (
          <LegendItem
            key={i}
            color={colorset[element.label]}
            label={element.label}
            text={element.text}
            t={t}
          />
        ))}
    </div>
  );
};

export default SleepLegend;

